import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommunicationAnalyticsActions } from './communication-analytics.actions';
import { AnalyticsQueryParams, AnalyticsTrendQueryParams } from '@app/core/api/analytics-shared';
import {
  selectCommunicationOverview,
  selectCommunicationTrend,
  selectCommunicationTimePattern,
  selectCommunicationLoading,
  selectCommunicationError
} from './communication-analytics.selectors';

@Injectable({
  providedIn: 'root'
})
export class CommunicationAnalyticsFacade {
  private readonly store = inject(Store);

  readonly overview$ = this.store.select(selectCommunicationOverview);
  readonly trend$ = this.store.select(selectCommunicationTrend);
  readonly timePattern$ = this.store.select(selectCommunicationTimePattern);
  readonly loading$ = this.store.select(selectCommunicationLoading);
  readonly error$ = this.store.select(selectCommunicationError);

  loadOverview(params: AnalyticsQueryParams): void {
    this.store.dispatch(CommunicationAnalyticsActions.loadOverview({ params }));
  }

  loadTrend(params: AnalyticsTrendQueryParams): void {
    this.store.dispatch(CommunicationAnalyticsActions.loadTrend({ params }));
  }

  loadTimePattern(params: AnalyticsQueryParams): void {
    this.store.dispatch(CommunicationAnalyticsActions.loadTimePattern({ params }));
  }

  clearState(): void {
    this.store.dispatch(CommunicationAnalyticsActions.clearCommunicationAnalyticsState());
  }
}
